import $ from "jquery";
import { toast } from "react-toastify";
import { apiURL } from "../utlis/config";
import store from "store";
// const apiURL = "http://172.105.35.119:8080/api";
var Actions = {
  ///trainee/notification
  addProductInfo: (info, method) => {
    toast.dismiss();
    return new Promise((resolve, reject) => {
      var url = apiURL + "/products";
      var settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: method,
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
          // fngprt: m.cookie.get("fngprt")
        },
        data: info,
        success: function (response) {
          // response = JSON.parse(response);
          if (response.error) {
            toast.error(response.memberMessage);
          } else {
            toast.info(response.memberMessage);
          }
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            // message.error("Your session has been expired. Please relogin.");
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            // message.error("Some error has occurred.");
          }
        },
      };
      $.ajax(settings).done();
    });
  },
  onProductReady: (productId, publicStatus) => {
    toast.dismiss();
    return new Promise((resolve, reject) => {
      var url = apiURL + "/product/" + productId + "/public";
      var settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: "PUT",
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
          // fngprt: m.cookie.get("fngprt")
        },
        data: { public: publicStatus },
        success: function (response) {
          // response = JSON.parse(response);
          if (response.error) {
            toast.error(response.memberMessage);
          } else {
            toast.info(response.memberMessage);
          }
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            // message.error("Your session has been expired. Please relogin.");
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            // message.error("Some error has occurred.");
          }
        },
      };
      $.ajax(settings).done();
    });
  },
  fetchProductsInfo: (
    productId,
    productStatus,
    page,
    pageSize,
    searchText,
    startDate,
    endDate
  ) => {
    console.log(
      { pageSize, page, searchText, startDate, endDate },
      "products=-----@"
    );
    //console.log("startDate  ==", startDate !== "" ? searchText : undefined)

    toast.dismiss();
    return new Promise((resolve, reject) => {
      var url = apiURL + "/products";
      var settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: "GET",
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
          // fngprt: m.cookie.get("fngprt")
        },
        data: {
          productId: productId,
          productStatus: productStatus,
          limit: pageSize,
          page: page,
          searchText: searchText !== "" ? searchText : undefined,
          startDate:
            startDate !== "" && startDate !== "Invalid date"
              ? startDate
              : undefined,
          endDate:
            endDate !== "" && endDate !== "Invalid date" ? endDate : undefined,
        },
        success: function (response) {
          if (!response.error) {
            toast.info(
              response.memberMessage,
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          } else {
            toast.error(
              response.memberMessage,
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          }
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            toast.error(
              "Your session has been expired. Please relogin.",
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            toast.error(
              "Some error has occurred.",
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          }
        },
      };
      $.ajax(settings).done();
    });
  },
  deactivateProductId: (productId) => {
    //deactivateMemberId
    toast.dismiss();
    return new Promise((resolve, reject) => {
      var url = apiURL + "/products";
      var settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: "DELETE",
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
          // fngprt: m.cookie.get("fngprt")
        },
        data: { productId },

        success: function (response) {
          if (!response.error) {
            toast.info(
              response.memberMessage,
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          } else {
            toast.error(
              response.memberMessage,
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          }
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            toast.error(
              "Your session has been expired. Please relogin.",
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            toast.error(
              "Some error has occurred.",
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          }
        },
      };

      $.ajax(settings).done();
    });
  },
  fetchProductList: () => {
    //console.log("startDate  ==", startDate !== "" ? searchText : undefined)

    toast.dismiss();
    return new Promise((resolve, reject) => {
      var url = apiURL + "/product/list";
      var settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: "GET",
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
          // fngprt: m.cookie.get("fngprt")
        },
        success: function (response) {
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            toast.error(
              "Your session has been expired. Please relogin.",
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            toast.error(
              "Some error has occurred.",
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          }
        },
      };
      $.ajax(settings).done();
    });
  },
};

export default Actions;
